jQuery(window).scroll(function () {
  var scroll = jQuery(window).scrollTop();

  if (scroll >= 50) {
    jQuery(".section-header.shopify-section-group-header-group").addClass(
      "header-fixed"
    );
  } else {
    jQuery(".section-header.shopify-section-group-header-group").removeClass(
      "header-fixed"
    );
  }

  if (scroll >= 900) {
          jQuery(".recently-viewed-products-section").addClass("show-info");
      } else {
          jQuery(".recently-viewed-products-section").removeClass("show-info");
      }
});

$(document).ready(function () {
  $("details.mega-menu, details.dropdown-nevigation").hover(function () {
    $(this).removeAttr("open");
    $(this).attr("open", "open");
  });

  $("details.mega-menu, details.dropdown-nevigation").mouseleave(function () {
    $(this).removeAttr("open");
  });

  $(".close--btn").click(function () {
    $('.recently-viewed-products-section').hide();
  });

  
});

// $(document).ready(function() {
//   $('details.mega-menu, ul.header__submenu, ul.header__subsubmenu').hover(function(){
//     $('summary.header__submenu-item').parent('details').removeAttr('open');
//     $(this).parent('details').attr('open','open');
//   });

//   $('details.mega-menu, ul.header__submenu').mouseleave(function(){
//     $(this).parent('details').removeAttr('open');
//   });
// });

// back to top js
$(document).ready(function () {
  // variables
  // var toTop = $(".footer .back-to-top .back-top-inner");
  // logic
  $(document).on("click", ".footer .back-to-top .back-top-inner", function () {
    $("html, body").animate({
      scrollTop: $("html, body").offset().top,
    });
  });
});

$(document).ready(function () {
  // $(".banner-with-breadcrumbs .back-to-bottom .back-bottom-inner").click(
  $(document).on(
    "click",
    ".banner-with-breadcrumbs .back-to-bottom .back-bottom-inner",
    function () {
      var nextSection = $(this).closest(".section").next();
      $("html, body").animate(
        {
          scrollTop: nextSection.offset().top - 80,
        },
        "slow"
      );
    }
  );
});
// End back to top js
function Hoveractive() {
  // $(".product-addd-to-cart").hover(function () {
  //   $(this).toggleClass("active");
  // });
  $(document).on('mouseenter mouseleave', '.product-addd-to-cart', function () {
    $(this).toggleClass('active');
  });
}
jQuery(document).ready(function () {
  jQuery("form.contact-form").validate();
  jQuery.extend(jQuery.validator.messages, {
    required: "Dieses Feld ist erforderlich.",
    email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    accept: "Bitte fügen Sie einen gültigen Dateityp hinzu.",
  });

  $(document).on("click", ".quantity__button", function () {
    $(".quantity__button.active").removeClass("active");
    $(this).addClass("active");
  });

  

  // $(".static-hover-addtocart").hover(
  //   function () {
  //     $(this).closest('.card__content').find('.product-addd-to-cart').addClass('active');
  //   },
  //   function () {
  //     $(this).closest('.card__content').find('.product-addd-to-cart').removeClass('active');
  //   }
  // );

  // $(".quick-add").hover(function() {
  //    $(this).closest('.card__content').find('.product-addd-to-cart').toggleClass('active');
  // });

  //$('body').on('hover','.product-addd-to-cart',function(){

  Hoveractive();
});
jQuery(document).ready(function () {
  /*$(document).on("click", ".js-load-more", function () {
    // console.log("hello");
    var $this = $(this),
      totalPages = parseInt($("[data-total-pages]").val()),
      currentPage = parseInt($("[data-current-page]").val());
    $this.attr("disabled", true);
    $this.find("[loader]").removeClass("hide");
    var currentPage = currentPage + 1;
    var nextUrl = $("[data-next-url]")
      .val()
      .replace(/page=[0-9]+/, "page=" + currentPage);
    $("[data-current-page]").val(currentPage);
    console.log(currentPage);
    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        $("#product-grid").append($(responseHTML).find("#product-grid").html());
      },
      complete: function () {
        console.log(currentPage, totalPages, currentPage <= totalPages);
        if (currentPage <= totalPages) {
          $this.attr("disabled", false);
          $this.find("[load-more-text]").removeClass("hide");
          $this.find("[loader]").addClass("hide");
        }
        if (currentPage == totalPages) {
          $this.addClass("hide");
        }
      },
    });
  });*/
});

// custom filter code
function collectionPage() {
  const $qs = (selector, ancestor = document) => {
    const a =
      ancestor === document || typeof ancestor === "object"
        ? ancestor
        : $qs(ancestor);
    return a.querySelector(selector);
  };
  const $qsa = (selector, ancestor = document) => {
    const a = ancestor === document ? ancestor : $qs(ancestor);
    return a.querySelectorAll(selector);
  };

  const on = (event, selector, fn, ancestor = "body") => {
    // console.log("$qs(ancestor)", $qs(ancestor));
    $qs(ancestor).addEventListener(event, function (event) {
      if (
        event.target &&
        event.target.matches &&
        event.target.matches(selector)
      ) {
        fn(event);
      }
    });
  };

  const updateCollectionURL = (handle,type) => {
    // window.history.replaceState({}, "", `/collections/${handle}`);
    if(type == 'Category'){
    // window.location.href=`/collections/${handle}`;
      window.location.href=`/collections/${handle}`;
    }else if(type == 'Custom URL'){
      window.location.href=handle;
    }
  };

  const getCollection = async (handle, section_id) => {
    let data = await fetch(
      `/collections/${handle}?section_id=${section_id}`
    ).then((res) => res.text());

    updateCollectionURL(handle,type);
    const parser = new DOMParser();
    $qs(`#shopify-section-${section_id}`).replaceWith(
      parser.parseFromString(data, "text/html").body.children[0]
    );

    // use of predefined hover function
    Hoveractive();
  };


  document.addEventListener("click", (e) => {
    $qsa(".selectDropdown").forEach((select) => {
    // console.log("❤️",e.target, $qs(".has_subnavigation span"), $qs(".has_subnavigation span") !== e.target);
      
      if ($qs(".has_subnavigation span.arrow") !== e.target && $qs(".selectBtn", select.parentNode) !== e.target) {
        // console.log("b",select,e.target,$qs(".has_subnavigation span.arrow"))
        select.classList.remove("toggle");
        select.parentNode.classList.remove("active");

      }
    });
  });

  

  on("click", ".selectBtn", (e) => {
    const btn = e.target;
    const elm = btn.closest(".select-custom");
    elm.classList.toggle("active");
    $qs(".selectDropdown", elm).classList.toggle("toggle");
  });

  on("click", ".option", (e) => {
    const option = e.target;
    const elm = option.closest(".select-custom");

    // remove other data-active and set to clicked option
    // console.log("ddd", $qs(".option[data-active]", elm))
    if ($qs(".option[data-active]", elm)) $qs(".option[data-active]", elm).removeAttribute("data-active");
    option.setAttribute("data-active", "");

    // change button text and attributes
    const btn = $qs(".selectBtn", elm);
    btn.setAttribute("data-type", option.getAttribute("data-type"));
    btn.innerText = option.innerText;

    // close dropdown
    $qs(".selectDropdown", elm).classList.toggle("toggle");

    // perform action
    switch (elm.dataset.action) {
      case "sort":
        $qs("#SortBy").value = option.getAttribute("data-type");
        $qs("#SortBy").closest("form").dispatchEvent(new Event("input"));
        break;

      case "collection":
        updateCollectionURL(option.getAttribute("data-type"),option.getAttribute("data-cat-type"))
        //getCollection(option.getAttribute("data-type"), elm.dataset.section);
        break;

      default:
        break;
    }
  });
}

if (location.pathname.includes("/collections/")) collectionPage();


$(document).ready(function(){
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {    
    if (links[i].hostname !== window.location.hostname && links[i].hostname !== 'trusetal.myshopify.com') {      
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }    
  }
});

$(document).ready(function(a){
  $('.custom-facets-wrap .select-custom .selectDropdown .main_option span').click(function() {
     $(this).closest('.custom-facets-wrap .select-custom .selectDropdown .main_option').toggleClass('submenuactive');
  });
  $(document).on("click", function(a) {
    if ($(a.target).is(".custom-facets-wrap .select-custom .selectDropdown .main_option span") === false) {
      $(".custom-facets-wrap .select-custom .selectDropdown .main_option").removeClass("submenuactive");
    }
  });
});

// Get height
function updateDivHeightsourServicesAroundSection() {
  $(".product .product.grid.product--large").each(function() {
    let ScrollbleDivHeight = $(this).height();
    $('.banner-with-breadcrumbs.banner--medium:not(.banner--adapt) .banner__media').get(0).style.setProperty("--ScrollbleDivHeight", ScrollbleDivHeight + "px");
  });
}

$(document).ready(function() {
  // Initial height calculation
  updateDivHeightsourServicesAroundSection();

  // Update heights on window resize
  $(window).resize(function() {
    updateDivHeightsourServicesAroundSection();
  });
  $( ".product .product__info-wrapper .product__description .toggle_show_more" ).on( "click", function() {
   updateDivHeightsourServicesAroundSection();
});

});
// var custom_drawer_clicked = false;
// window.addEventListener("cart_changed", function(e){
//    console.log('gere', $(".custom-drawer").length);
//    if(e.type == 'cart_changed' && $(".custom-drawer").length == 1 && custom_drawer_clicked === true) {
//       $('.cart-notification-wrapper').hide();
//       // setTimeout(() => {
//         $(document).find('.quickcheckout-btn').click();
//         $('.aico-quick-checkout-form-drawer').addClass('open');
//       // }, 3000);
//       //aicoQuickCheckoutHTML();
//    }
// }); 
// Remove the display property from buttons with type="submit"
// $('button[type="submit"]').removeAttr('disabled');
$(document).on("click", ".custom-drawer", function(event) {
    // custom_drawer_clicked = true;
    $('.cart-notification-wrapper').hide();
    $(".quickcheckout-btn").removeAttr('disabled');
    setTimeout(() => {
        $(document).find('.quickcheckout-btn').click();
        $('.aico-quick-checkout-form-drawer').addClass('open');
    }, 1000);
});
// End Get height